var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeco(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 28",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6584 9.46202C13.6584 6.44758 12.0804 3.85442 10.8807 3.0101C10.875 3.00832 10.7895 2.9623 10.7971 3.08267C10.7971 3.08444 10.7952 3.08444 10.7952 3.08621C10.6963 8.90799 7.50226 10.4851 5.74554 12.611C1.69215 17.5159 5.46226 22.8934 9.30081 23.8863C11.4492 24.4421 8.80459 22.9022 8.46427 19.6488C8.05171 15.7175 13.6584 12.7172 13.6584 9.46202Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5245 11.4465C15.4997 11.4305 15.4655 11.42 15.4408 11.4571C15.3742 12.1899 14.57 13.7582 13.551 15.1972C10.0946 20.0791 12.0642 22.4334 13.1727 23.6972C13.8153 24.4318 13.1727 23.6972 14.7792 22.9467C14.9047 22.8882 17.9162 21.3164 18.2413 17.7355C18.5588 14.268 16.3211 12.082 15.5245 11.4465Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeco);
export default __webpack_public_path__ + "static/media/heco.be3f7c8c.svg";
export { ForwardRef as ReactComponent };